import { gql } from '@apollo/client';

export default gql`
  query AllPanelistsQuery(
    $workspaceId: Int!
    $recentDate: Datetime!
    $filter: UserFilter
    $orderBy: [UsersOrderBy!]
    $after: Cursor
    $before: Cursor
    $first: Int
    $last: Int
    $offset: Int
  ) {
    panelists: allPanelists(
      workspaceId: $workspaceId
      filter: $filter
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      offset: $offset
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          username
          email
          phoneNumber
          interfaceLanguage
          ethnicity
          lastActive
          productReviews: productReviewsByUserId(
            filter: {
              panelByPanelId: { producerId: { equalTo: $workspaceId } }
            }
          ) {
            totalCount
            nodes {
              id
              dataQuality: dataQualityByReviewId {
                allGgVar
                ggVarMax
                insufficientGgVar
                noRefFlavor
                excessiveRefFlavor
                shortReviewTime
                buttonMashing
                timeTaken
              }
            }
          }
          recentReviews: productReviewsByUserId(
            filter: { startTime: { greaterThanOrEqualTo: $recentDate } }
          ) {
            totalCount
            nodes {
              id
              dataQuality: dataQualityByReviewId {
                allGgVar
                ggVarMax
                insufficientGgVar
                noRefFlavor
                excessiveRefFlavor
                shortReviewTime
                buttonMashing
                timeTaken
              }
            }
          }
        }
      }
    }
  }
`;
